export default (state = {}, action) => {
  switch (action.type) {
    case 'SET_AUTH_INFO':
      return { ...action.authInfo };
    default:
      return state;
  }
};
